import type { CustomerInfo, PurchasesPackage } from 'react-native-purchases'
import Purchases from 'react-native-purchases'
import { PurchasesCommon } from '@revenuecat/purchases-js-hybrid-mappings'

function isPurchasesCommonConfigurationError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false
  }

  return /purchases(common)? (is )?not configured|call (setup)?configure\(\)? first/i.test(
    error.message,
  )
}

export async function purchasePackageOnWeb(
  pkg: PurchasesPackage,
  userEmail: string | null,
  userDisplayName: string | null,
  locale: 'en' | 'sv',
): Promise<CustomerInfo> {
  try {
    const result = await PurchasesCommon.getInstance().purchasePackage({
      packageIdentifier: pkg.identifier,
      presentedOfferingContext: pkg.presentedOfferingContext ?? {},
      customerEmail: userEmail ?? undefined,
      selectedLocale: locale,
      defaultLocale: locale,
      metadata:
        userDisplayName != null && userDisplayName.trim().length > 0
          ? {
              display_name: userDisplayName.trim(),
            }
          : undefined,
    })
    return result.customerInfo
  } catch (error) {
    if (!isPurchasesCommonConfigurationError(error)) {
      throw error
    }

    const result = await Purchases.purchasePackage(pkg)
    return result.customerInfo
  }
}
